import {
  Box,
  Button,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaFileExport, FaPlay } from "react-icons/fa";
import {
  simplifiedExtract,
} from "../../../interfaces/defaultInterfaces";
import { JWTToken } from "../../../routes/privateRoute";
import ExtratoApi from "../../../services/ExtratoAPI";
import moment from "moment";
import jwt_decode from "jwt-decode";
import DateDropdownFuture from "../../../defaultComponents/dateDropdownFuture";
import TableSalesCredit from "../consultaTransacoes/defaultComponents/tableSalesCredit";
import { useSetRecoilState, useRecoilState } from "recoil";
import { customColors } from "../../../atoms/customColors";
import fileDownload from "js-file-download";
import { toast } from "react-toastify";

export default function FutureReleases() {
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const id = Number(jwtToken.idCliente);
  const colors = useRecoilState(customColors)[0];

  const dataInicio = moment(Date())
    .add(1, "day")
    .startOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");
  const dataFim = moment(Date())
    .add(1, "day")
    .endOf("day")
    .format("YYYY-MM-DDTHH:mm:ss");


  const [extractList, setExtractList] = useState(Array<simplifiedExtract>);
  const initialValues = {
    initialDateFilter: dataInicio,
    finalDateFilter: dataFim,
  };

  const [filtros, setFiltros] = useState(initialValues);
  const [loading, setLoading] = useState(false);

  let dias = moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >= 32;

  async function getExtractDetails() {
    try {
      setLoading(true);
      const response = await ExtratoApi.getExtractPerClient(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        id
      );
      setExtractList(response.data);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
    }
  }

  async function Export() {
    try {
      setLoading(true);
      const response = await ExtratoApi.exportExtract(
        1,
        100,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        "",
        true,
      );
      fileDownload(response, "relatorio.xlsx");
      setLoading(false);
    } catch (error) {
      toast.error("Não foi possível exportar o arquivo!");
      setLoading(false);
    }
  }

  useEffect(() => {
    getExtractDetails();
  }, [filtros.initialDateFilter, filtros.finalDateFilter]);

  return (
    <Flex
      w={"100%"}
      h={"100%"}
      bgColor={colors.WHITE}
      shadow={"xl"}
      flexDirection={"column"}
      overflowY={"scroll"}
    >
      <Box mb={"10px"} width={"100%"} height={"fit-content"} mx="auto" px={3}>
        <Flex px={8} alignItems="center">
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            my={4}
            color={colors.BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Lançamentos Futuros
          </Text>
        </Flex>
      </Box>
      <Flex
        w={"97%"}
        h={"8%"}
        py={4}
        px={10}
        marginX={"auto"}
        mb={4}
        border={"2px solid #e3e3e3"}
        shadow={"md"}
        borderRadius={"8px"}
        justifyContent={"space-evenly"}
        alignItems={"center"}
      >
        <DateDropdownFuture filtros={filtros} setFiltros={setFiltros} />
        <Button
          bg={"none"}
          color={colors.BLUEMONEDDBUTTONS}
          isDisabled={loading || dias}
          onClick={() => {
            Export();
          }}
          mx="10px"
          isLoading={loading}
          textTransform={"uppercase"}
          leftIcon={<FaFileExport />}
        >
          {/* <Icon mr={2} as={FaFileExport} /> */}
          <Text fontSize={"0.8rem"}>Exporte o seu relatório</Text>
        </Button>
      </Flex>
      <Flex
        w={"100%"}
        h={"60vh"}
        alignItems={"flex-start"}
        px={5}
        flexDirection={"column"}
      >
        {extractList?.filter(
          (item: any) =>
            // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
            item.tipoLancamento.id == 1
        ).length ? (
          <TableSalesCredit
            data={
              extractList &&
              extractList.filter(
                (item: any) =>
                  // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
                  item.tipoLancamento.id == 1
              )
            }
            title={"Vendas no cartão de Crédito"}
          />
        ) : (
          <></>
        )}
        {extractList?.filter(
          (item: any) =>
            // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
            item.tipoLancamento.id == 2
        ).length ? (
          <TableSalesCredit
            data={
              extractList &&
              extractList.filter(
                (item: any) =>
                  // item.tipoLancamento.lancamento == "Venda Cartão Crédito"
                  item.tipoLancamento.id == 2
              )
            }
            title={"Cancelamentos de Vendas no Cartão"}
          />
        ) : (
          <></>
        )}
      </Flex>
    </Flex>
  );
}
